import actionTypes from 'dashboard/actions/earnings-history/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_EARNINGS_HISTORY_SUCCESS:
      return [...action.data];
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/earnings-history/earnings-history.js